// extracted by mini-css-extract-plugin
export default {"toggle":"styles-module__toggle__src-labstep-web-core-Label-Toggle-__Rclm","container":"styles-module__container__src-labstep-web-core-Label-Toggle-_nzOw4"};